export default __webpack_public_path__ + "static/media/fuzzing-full-macos.8b7c55f3.avif";